import { useQueryClient } from 'shared-ui';
import { toast } from 'react-toastify';

import { unarchiveCard } from 'api/cards/cards';
import { QueryKeyEnum } from 'core/global.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { AppRouteWithParams } from 'routing/AppRoute.enum';
import { useMutation } from 'hooks/useMutation/useMutation';
import { useIsExactPath } from 'hooks/useIsExactPath/useIsExactPath';
import { useModalState } from 'hooks/useModalState/useModalState';

import { UnarchiveCard } from './UnarchiveCard';
import { UnarchiveCardContainerProps } from './UnarchiveCard.types';

export const UnarchiveContainer = ({ selectedCard, setSelectedCard }: UnarchiveCardContainerProps) => {
  const queryClient = useQueryClient();
  const isHistoryView = useIsExactPath(AppRouteWithParams.cardHistory.path);
  const { formatMessage } = useLocale();

  const { isModalOpen, onModalOpen, onModalClose } = useModalState();

  const { mutate: onUnarchiveCard, isLoading } = useMutation(unarchiveCard, {
    onSuccess: (updatedCard) => {
      if (isHistoryView) {
        setSelectedCard(updatedCard);
        queryClient.invalidateQueries([QueryKeyEnum.CARD_HISTORY]);
      } else {
        queryClient.invalidateQueries([QueryKeyEnum.CARDS]);
        setSelectedCard(undefined);
      }

      toast.dark(formatMessage({ id: AppMessages['card.unarchive.success'] }));
      onModalClose();
    },
  });

  const onSubmit = () => {
    onUnarchiveCard(selectedCard.id);
  };

  return (
    <UnarchiveCard
      selectedCard={selectedCard}
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      onModalOpen={onModalOpen}
      isLoading={isLoading}
      onSubmit={onSubmit}
    />
  );
};
